
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiKeepingStation as ObiKeepingStationElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-keeping-station.js';
 
 
 

 
 export const ObiKeepingStation = createComponent({
   react: React,
   tagName: 'obi-keeping-station',
   elementClass: ObiKeepingStationElement,
   events: {
     
   }
  });
 
 